<script>
  import {
    MoreVerticalIcon
  } from 'vue-feather-icons'

  export default {
    components: {
      MoreVerticalIcon,
    },
    props: {
      isDisabled: {
        type: Boolean,
        default: false,
      },
      isPositiveDisabled: {
        type: Boolean,
        default: false,
      },
      isNegativeDisabled: {
        type: Boolean,
        default: false,
      },
      isExtraPositiveDisabled: {
        type: Boolean,
        default: false,
      },
      isExtraNegativeDisabled: {
        type: Boolean,
        default: false,
      },
      hasExtraNegative: {
        type: Boolean,
        default: false,
      },
      hasExtraPositive: {
        type: Boolean,
        default: false,
      },
      updateText:{
        type: String,
        default: 'Save Details',
      },
      cancelText:{
        type: String,
        default: 'Cancel',
      },
      isInsideModal:{
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        popperProps: {
          eventsEnabled: false,
        },
      }
    },
    methods:{
      forcePanBottom(){
        setTimeout(() => {
          if ((window.scrollY + document.body.clientHeight) !== document.body.scrollHeight){
            window.scrollTo(0, document.body.scrollHeight);
          }
        });
      }
    }
  }
</script>

<template>
  <footer
    class="footer-actions tw-flex tw-flex-col-reverse md:tw-flex-row tw-w-full"
    :class="{
      'tw-gap-x-2 mlModal:tw-gap-x-0 tw-flex-nowrap': isInsideModal,
    }">
    <span
      class="tw-flex tw-flex-row tw-w-full md:tw-w-1/2"
      :class="{
        'tw-max-w-u md:tw-max-w-[14rem] mlModal:tw-max-w-u': isInsideModal,
      }">
      <button
        type="button"
        class="btn btn-outline-white md:!tw-w-60 !tw-w-full md:tw-mb-0 tw-mb-2"
        :disabled="isDisabled || isNegativeDisabled"
        @click="$emit('footer-cancel')">{{cancelText}}</button>
      <FabricDropdown
        v-if="hasExtraNegative"
        :disabled="isDisabled || isExtraNegativeDisabled"
        text="Dropdown Button"
        :offset="1"
        dropup
        lazy
        variant="red"
        right
        :popper-opts="popperProps"
        class="dropdown-circle dropdown-borded negative tw-ml-4 tw-inline-flex md:tw-hidden"
        toggle-class="!tw-min-w-u"
        @show="forcePanBottom">
        <template v-slot:button-content>
          <MoreVerticalIcon size="1.5x" class="fl-inline"/>
        </template>
        <slot name="extra-negative" />
      </FabricDropdown>
      <FabricDropdown
        v-if="hasExtraNegative"
        :disabled="isDisabled || isExtraNegativeDisabled"
        text="Dropdown Button"
        :offset="1"
        dropup
        lazy
        variant="red"
        :popper-opts="popperProps"
        class="dropdown-circle dropdown-borded negative tw-ml-4 tw-hidden md:tw-inline-flex"
        toggle-class="!tw-min-w-u"
        @show="forcePanBottom">
        <template v-slot:button-content>
          <MoreVerticalIcon size="1.5x" class="fl-inline"/>
        </template>
        <slot name="extra-negative" />
      </FabricDropdown>
    </span>
    <span
      class="tw-flex tw-flex-row md:tw-flex-row-reverse tw-w-full md:tw-w-1/2"
      :class="{
        'tw-max-w-u md:tw-max-w-[14rem] mlModal:tw-max-w-u': isInsideModal,
      }">
      <button
        type="button"
        :disabled="isDisabled || isPositiveDisabled"
        class="btn btn-positive md:!tw-w-80 !tw-w-full md:tw-mb-0 tw-mb-2"
        @click="$emit('footer-update')">{{updateText}}</button>
      <FabricDropdown
        v-if="hasExtraPositive"
        :disabled="isDisabled || isExtraPositiveDisabled"
        text="Dropdown Button"
        :offset="1"
        dropup
        lazy
        variant="blue-dark"
        right
        :popper-opts="popperProps"
        class="dropdown-circle dropdown-borded positive tw-ml-4 md:tw-mr-4 tw-inline-flex"
        toggle-class="!tw-min-w-u"
        @show="forcePanBottom">
        <template v-slot:button-content>
          <MoreVerticalIcon size="1.5x" class="fl-inline"/>
        </template>
        <slot name="extra-positive" />
      </FabricDropdown>
    </span>
  </footer>
</template>
